import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {TextFieldModule} from '@angular/cdk/text-field';
import { MatHorizontalStepperDirectiveDirective } from './mat-horizontal-stepper-directive.directive';

@NgModule({
  exports: [
    MatButtonModule,
    MatStepperModule,
    MatExpansionModule,
    MatDividerModule,
    MatPaginatorModule,
    MatBadgeModule,
    MatDatepickerModule,
    TextFieldModule,
    // MatHorizontalStepperDirectiveDirective
  ],
  declarations: [
    MatHorizontalStepperDirectiveDirective
  ]
})
export class MaterialModule {}
